import React from "react";
import CampoEditableFechaCampos from "../../UI/campos/CampoEditableFechaCampos.js";
import CampoEditableTexto from "../../UI/campos/CampoEditableTexto.js";
import CampoEditableMultilinea from "../../UI/campos/CampoEditableMultilinea.js";
import * as Campos from "../../constantes/Campos.js";
import LargoCampos from "../../largoCampos/LargoCampos.js";
import styles from "../EditarItemLista.module.css";

const CamposEstadioNombre = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Nombre</td>
        <td className={`${styles.valor}`}>
          <CampoEditableTexto
            nombre={Campos.NombreEstadio.NOMBRE}
            valor={item && item.nombre}
            largo={LargoCampos.NOMBRE_COMUN}
            editar={editar}
            width="24rem"
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Desde</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.NombreEstadio.FECHA_DESDE}
            anio={item && item.anioDesde}
            mes={item && item.mesDesde}
            dia={item && item.diaDesde}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Hasta</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.NombreEstadio.FECHA_HASTA}
            anio={item && item.anioHasta}
            mes={item && item.mesHasta}
            dia={item && item.diaHasta}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Observaciones</td>
        <td className={`${styles.valor}`}>
          <CampoEditableMultilinea
            filas="3"
            columnas="46"
            nombre={Campos.NombreEstadio.OBSERVACIONES}
            valor={item && item.observaciones}
            largo={LargoCampos.OBSERVACIONES}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposEstadioNombre;
